import React from "react"
import QuietNotes from "../components/previews/QuietNotes"
import { usePreviewPosts, withPreviewLinks } from "../components/previews/data"
import SEO from "../components/seo"

export default function BlogIndex() {
  const posts = withPreviewLinks(usePreviewPosts(), "")
  return (
    <>
      <SEO title="A notebook, kept open" pathname="/" />
      <a className="quiet-skip" href="#quiet-main">Skip to the notes</a>
      <QuietNotes posts={posts} basePath="" />
    </>
  )
}
